import { temAcesso } from '@/shared/auth/temAcesso'

const SolicitacoesReaberturas = () => import('./SolicitacoesReaberturas.vue')

export default {
    path: 'solicitacoesReaberturas',
    name: 'Uabs_SolicitacoesReaberturas',
    component: SolicitacoesReaberturas,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-UABS-ENTR-06')) {
            next()
        }
    }
}
